import ScrollBar from "react-perfect-scrollbar";
import { NavbarMenu } from "../components";
import "./style.scss";
import "react-perfect-scrollbar/dist/css/styles.css";
import { Footer } from "../components";
import { Route, Switch, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect, useLayoutEffect } from "react";
import languge from "../redux/language";
import routes from "../app-routes";
import ResponsiveFooter from "../components/footer/responsiveFooter";
const Base = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(languge.actions.getLanguages());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const location = useLocation();
  // Scroll to top if path changes
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <div className="base-screen">
      <NavbarMenu />
      <div className="content">
        <ScrollBar>
          <Switch>
            {routes.map(({ path, component }) => {
              return (
                <Route exact key={path} path={path} component={component} />
              );
            })}
          </Switch>
          <Footer /> <ResponsiveFooter />
        </ScrollBar>
      </div>
    </div>
  );
};
export default Base;
